import { Zap as ZapIcon } from 'lucide-react'
import cn from 'classnames'

import Title from 'components/typography/Title'

export interface Props {
  onWakeUpClick: (e: any) => void
  isHidden?: boolean
}

function SessionAsleepScreen({
  onWakeUpClick,
  isHidden,
}: Props) {
  return (
    <div
      className={cn(
        { 'opacity-0': isHidden },
        { 'opacity-1': !isHidden },
        { 'pointer-events-auto': !isHidden },
        { 'pointer-events-none': isHidden },
        'absolute',
        'inset-0',
        'top-[2.5rem]',
        'lg:top-0',
        'h-full',
        'w-full',
        'bg-black/50',
        'z-30',
        'flex',
        'flex-col',
        'space-y-4',
        'items-center',
        'justify-center',
        'transition-all',
        'duration-500'
      )}
      // Add the `hidden` attribute so Tailwind doesn't
      // apply spacing to this element.
      hidden={isHidden}
    >
      <Title
        size={Title.size.T2}
        title="Session Asleep"
      />
      <button
        className="
          group
          flex
          cursor-pointer
          items-center
          space-x-1.5
          rounded-lg
          bg-gradient-to-r
          from-indigo-600 to-indigo-400 py-1
          px-2
          shadow-lg
          shadow-indigo-600/70
          transition-all
          duration-300
          ease-in-out
          hover:shadow-indigo-600
        "
        onClick={onWakeUpClick}
      >
        <span
          className="
          text-sm
          font-semibold
          text-white
        "
        >
          Move mouse to wake up the session
        </span>
      </button>
    </div>
  )
}

export default SessionAsleepScreen
